import { AxiosInstance, InternalAxiosRequestConfig, AxiosHeaders, AxiosResponse } from "axios";
import { readConfigFile } from "utils/appConfig";
import { clearLocalStorage, loadTokenLocalStorage } from "utils/auth/localStorage";
import TokenService from "utils/auth/Token.service";
import initializeConfig from "./api.config";

export const redirectToLogin = async () => {
  const { WebsiteUrl } = await initializeConfig();
  clearLocalStorage();
  window.location.replace(WebsiteUrl);
};

export const interceptorBeforeRequest = async (instance: AxiosInstance) => {
  instance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      const tokenService = new TokenService();
      const token = tokenService.getToken() || "";
      const tokenCode = loadTokenLocalStorage();
      try {
        if (!token && !tokenCode) {
          redirectToLogin();
        } else {
          const getConfig = await readConfigFile();

          if (!config.headers) {
            config.headers = new AxiosHeaders();
          }

          config.headers.set("Authorization", `Bearer ${token}`);
          config.headers.set("Ocp-Apim-Subscription-Key", getConfig.VITE_YMS_APIM_SUBS_KEY);
        }
        return config;
      } catch (error) {
        console.error("Erro ao obter configuração:", error);
        return Promise.reject(error);
      }
    },
    (error) => Promise.reject(error)
  );
};

export const interceptorAfterResponse = async (instance: AxiosInstance) => {
  instance.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    async (error) => {
      if (error.response?.status === 401) {
        const tokenService = new TokenService();
        const { WebsiteUrl } = await initializeConfig();
        tokenService.deleteToken();
        clearLocalStorage();
        window.location.replace(`${WebsiteUrl}`);
      }
      return Promise.reject(error);
    }
  );
};
